
























































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import barListData from './json/barListData.json'
import preColors from './json/pre_colors.json'
import temColors from './json/tem_colors.json'
import windElement from '@/utils/windElement'
import staIdsData from '@/utils/staIdsData.json'

export default Vue.extend({
    data() {
        return {
            barListData,
            barId: '',
            subListData: []as any,
            subId: '',
            startTime: '',
            endTime: '',
            timeTag: 0,
            timeShow: false,
            minDate: new Date(2019, 0, 1, 0),
            maxDate: new Date(),
            currentDate: new Date(),
            initData: [],
            timeRange: '',
            timeStr: '',
            hourNum: 0,
        }
    },
    created() {
        this.barId = this.$route.params.id
        barListData.filter((e) => {
            if (e.id === this.barId) {
                if (e.children) {
                    this.subListData = e.children
                } else {
                    this.subListData = []
                }
            }
        })
        if (this.subListData.length > 0) {
            this.subId = this.subListData[0].id
        } else {
            this.subId = 'rhu'
        }
        if (this.barId !== 'pre') {
            this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
            this.getliveData()
        } else {
            this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
            const start = moment(new Date()).add(-8,'hours').format('YYYYMMDDHH0000')
            const end = moment(new Date()).add(-8,'hours').format('YYYYMMDDHH0000')
            this.timeRange = `${start},${end}`
            this.getStatData()
        }
    },
    methods: {
        changeBar(id: any) {
            this.hourNum = 0
            this.barId = id
            if (id !== 'radar' && id !== 'satellite') {
                barListData.filter((e) => {
                    if (e.id === this.barId) {
                        if (e.children) {
                            this.subListData = e.children
                        } else {
                            this.subListData = []
                        }
                    }
                })
                if (this.subListData.length > 0) {
                    this.subId = this.subListData[0].id
                } else {
                    this.subId = 'rhu'
                }
                this.$emit('changeBar', id)
                if (this.barId !== 'pre') {
                    this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
                    this.getliveData()
                } else {
                    this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
                    const start = moment(new Date()).add(-8,'hours').format('YYYYMMDDHH0000')
                    const end = moment(new Date()).add(-8,'hours').format('YYYYMMDDHH0000')
                    this.timeRange = `${start},${end}`
                    this.getStatData()
                }
            } else {
                // console.log(id)
                this.$emit('changeBar', id)
                const params = {
                    data: [],
                    timeStr: '',
                }
                this.$emit('getData', params)
            }
        },
        changeSub(id: any) {
            this.subId = id
            if (id === 'pre_any') {
                this.startTime = moment(this.currentDate).format('YYYY-MM-DD HH:00')
                this.endTime = moment(this.currentDate).format('YYYY-MM-DD HH:00')
                this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
            }
            if (this.barId === 'pre') {
                this.hourNum = 0
                const num = this.subId.split('_')[1].split('h')[0]
                const start = moment(new Date()).add(- (Number(num) - 1), 'hours').format('YYYYMMDDHH0000')
                const end = moment(new Date()).format('YYYYMMDDHH0000')
                this.timeRange = `${start},${end}`
                if (num === '1') {
                    this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
                } else {
                    this.timeStr = `${moment(new Date()).add(- (Number(num)), 'hours').format('YYYY年MM月DD日HH时')}-${moment(new Date()).format('YYYY年MM月DD日HH时')}`
                }
                this.getStatData()
            } else if (this.barId === 'tem' && this.subId !== 'tem') {
                const start = moment(new Date()).add(-24, 'hours').format('YYYYMMDDHH0000')
                const end = moment(new Date()).format('YYYYMMDDHH0000')
                this.timeRange = `${start},${end}`
                this.timeStr = `${moment(new Date()).add(-24, 'hours').format('YYYY年MM月DD日HH时')}-${moment(new Date()).format('YYYY年MM月DD日HH时')}`
                this.getStatData()
            } else if (this.barId === 'tem' && this.subId === 'tem') {
                this.hourNum = 0
                this.timeStr = moment(new Date()).format('YYYY年MM月DD日HH时')
                this.getliveData()
            } else {
                this.getTableData()
            }
        },
        // 任意时间查询
        changeTime(value: any) {
            this.timeTag = value
            this.timeShow = true
            if (this.timeTag === 1) {
                const arr = this.startTime.split(':')[0].split(' ')[0].split('-')
                arr.push(this.startTime.split(':')[0].split(' ')[1])
                this.currentDate = new Date(Number(arr[0]), Number(arr[1]) - 1, Number(arr[2]), Number(arr[3]))
            } else {
                const arr = this.endTime.split(':')[0].split(' ')[0].split('-')
                arr.push(this.endTime.split(':')[0].split(' ')[1])
                this.currentDate = new Date(Number(arr[0]), Number(arr[1]) - 1, Number(arr[2]), Number(arr[3]))
            }
        },
        confirm() {
            this.timeShow = false
            if (this.timeTag === 1) {
                this.startTime = moment(this.currentDate).format('YYYY-MM-DD HH:00')
            } else {
                this.endTime = moment(this.currentDate).format('YYYY-MM-DD HH:00')
            }
        },
        cancel() {
            this.timeShow = false
        },
        query() {
            // console.log(this.startTime)
            // console.log(this.endTime)
            const arrStart = this.startTime.split(' ')
            const arrEnd = this.endTime.split(' ')
            const start = arrStart[0].replace(/-/g, '') + arrStart[1].split(':')[0] + '0000'
            const end = arrEnd[0].replace(/-/g, '') + arrEnd[1].split(':')[0] + '0000'
            this.timeRange = `${start},${end}`
            this.timeStr = `${moment(start, 'YYYYMMDDHHmmss').format('YYYY年MM月DD日HH时')}-${moment(end, 'YYYYMMDDHHmmss').format('YYYY年MM月DD日HH时')}`
            this.getStatData()
        },
        getliveData() {
            const url = '/cw/surface_data/list/surf_hour_data'
            const params = {
                // adminCodes: config.defaultStationObj.adminCode,
                staIds: config.staIds,
                elements: 'station_name,station_id_c,tem,tem_min,tem_max,win_s_avg_2mi,win_d_avg_2mi,win_s_inst_max,win_d_inst_max,rhu,lat,lon,datetime',
            }
            request.get(url, params).then((data) => {
                data.map((e: any) => {
                    staIdsData.map((i: any) => {
                        if (e.station_id_c === i.station_id_c) {
                            e.station_name = i.station_name
                            e.lon = i.lon
                            e.lat = i.lat
                        }
                    })
                })
                this.initData = data
                this.getTableData()
            })
        },
        getStatData() {
            // console.log(this.timeRange)
            const url = '/cw/surface_stat/list/surf_hour_data'
            const params = {
                // adminCodes: config.defaultStationObj.adminCode,
                staIds: config.staIds,
                elements: 'station_name,station_id_c,pre_1h,tem_min,tem_max,lat,lon,datetime',
                timeRange: this.timeRange,
            }
            request.get(url, params).then((data) => {
                // console.log(data)
                data.map((e: any) => {
                    staIdsData.map((i: any) => {
                        if (e.station_id_c === i.station_id_c) {
                            e.station_name = i.station_name
                            e.lon = i.lon
                            e.lat = i.lat
                        }
                    })
                })
                this.initData = data
                this.getTableData()
            })
        },
        changeHour(value: any) {
            // console.log(value)
            let num = this.hourNum
            if (value === 'back' && this.hourNum > -6) {
                if (this.hourNum <= 0 && this.hourNum > -6) {
                    num--
                }
                this.hourNum = num
            } else if (value === 'next' && this.hourNum < 0) {
                if (this.hourNum < 0 && this.hourNum >= -6) {
                    num++
                }
                this.hourNum = num
            }
            console.log(this.hourNum)
            this.timeStr = moment().add(this.hourNum, 'hour').format('YYYY年MM月DD日HH时')
            this.gethistData()
        },
        gethistData() {
            const times = `${moment().add(this.hourNum, 'hours').add(-8,'hours').format('YYYYMMDDHH0000')}`
            const url = '/cw/surface_data/list/surf_hour_data'
            const params = {
                // adminCodes: config.defaultStationObj.adminCode,
                staIds: config.staIds,
                elements: 'station_name,station_id_c,pre_1h,tem,win_s_avg_2mi,win_d_avg_2mi,win_s_inst_max,win_d_inst_max,rhu,lat,lon,datetime',
                times,
            }
            request.get(url, params).then((data) => {
                // console.log(data)
                data.map((e: any) => {
                    staIdsData.map((i: any) => {
                        if (!e.station_name && e.station_id_c === i.station_id_c) {
                            e.station_name = i.station_name
                        }
                    })
                })
                this.initData = data
                this.getTableData()
            })
        },
        getTableData() {
            // console.log(this.initData)
            // console.log(this.subId)
            const data = JSON.parse(JSON.stringify(this.initData))
            data.map((e: any) => {
                let key = this.subId
                if (this.barId === 'pre') {
                    key = 'pre_1h'
                }
                e.value = e[key]
                let arrBgColor = []as any
                if (this.barId === 'wind') {
                    e.bgColor = ''
                    e.level = windElement.windLevel(e[this.subId])
                    e.windImg = windElement.windVane(e.value)
                    if (this.subId === 'win_s_avg_2mi') {
                        e.rotate = e.win_d_avg_2mi
                    } else if (this.subId === 'win_d_inst_max') {
                        e.rotate = e.win_d_inst_max
                    }
                } else if (this.barId === 'rhu') {
                    e.bgColor = '#00BFFF'
                } else if (this.barId === 'pre') {
                    arrBgColor = preColors
                } else if (this.barId === 'tem') {
                    arrBgColor = temColors
                }
                arrBgColor.map((k: any) => {
                    if (e.value >= k[0] && e.value < k[1]) {
                        e.bgColor = `rgba(${k[2]}, ${k[3]}, ${k[4]}, 1.0)`
                        if (e.value < 0.09) {
                            e.bgColor = '#00BFFF'
                        }
                    }
                })
            })
            let arr = data
            if(this.barId !== 'tem'){
             arr = data.filter((e: any) => {
                return e.value >= 0
            })
            }
            // console.log(data)
            // console.log(this.timeStr)
            const params = {
                // data,
                data: arr,
                timeStr: this.timeStr,
            }
            this.$emit('getData', params)
        },
    },
})
